import { API_HOST, getHttpPostOptions, getHttpGetOptions } from '../../../utils/api-util';

const getEndpoint = () => `${API_HOST}/admin/user-role-management`;

const getViewStaffEndpoint = () => `${getEndpoint()}/view/staff`;
export const getViewStaffRequest = (filters) => [getViewStaffEndpoint(), getHttpPostOptions(filters)];

const getUpdateUserGroupsEndpoint = () => `${getEndpoint()}/update/groups`;
export const getUpdateUserGroupsRequest = (groups) => [getUpdateUserGroupsEndpoint(), getHttpPostOptions(groups)];

const getPopulateDropdownsEndpoint = () => `${getEndpoint()}/populate-dropdowns`;
export const getPopulateDropdownsRequest = () => [getPopulateDropdownsEndpoint(), getHttpGetOptions()];
